query AnalyticsViewsByDeviceType($filter: AnalyticsViewsFilterInput!) {
  analyticsViews(filter: $filter) {
    viewsByDeviceType {
      label
      views
    }
  }
}
